import UAParser from "ua-parser-js"

export const UserAgent = {
  get: () => {
    if (typeof navigator === "undefined") return null

    try {
      const parser = new UAParser(navigator.userAgent)
      return parser.getResult()
    } catch (error) {
      // Unsupported/Blocked by the browser
      return null
    }
  },

  getBrowserName: () => {
    const userAgent = UserAgent.get()

    return userAgent?.browser.name
  },

  isBot: (ua?: string) => {
    const userAgent = ua ?? UserAgent.get()?.ua
    if (!userAgent) {
      return false
    }

    // tester- is used as a prefix for the user agent on our tests (Datadog Syntethics)
    // The list of the bots https://udger.com/resources/ua-list/crawlers
    return /tester-|bot|crawler|spider|crawling|HeadlessChrome|Googlebot|Mediapartners-Google|AdsBot-Google|googleweblight|Storebot-Google|Google-PageRenderer|Bingbot|BingPreview|Slurp|DuckDuckBot|baiduspider|yandex|sogou|LinkedInBot|bitlybot|tumblr|vkShare|quora link preview|facebookexternalhit|facebookcatalog|Twitterbot|applebot|redditbot|Slackbot|Discordbot|WhatsApp|SkypeUriPreview|ia_archiver|meta-externalagent|AhrefsBot|OAI-SearchBot|GPTBot/i.test(
      userAgent,
    )
  },

  isSafari: (): boolean => {
    const browserName = UserAgent.getBrowserName() ?? ""

    return browserName.includes("Safari")
  },

  isSafariMobile: (): boolean => {
    return UserAgent.getBrowserName() === "Mobile Safari"
  },
}
